import { ProfileScreen } from "../screens/account/ProfileScreen";
import { ResetPasswordScreen } from "../screens/account/ResetPasswordScreen";
import { TrackingCodeScreen } from "../screens/shipper/TrackingCodeScreen";
import { TrackingCodeShipperScreen } from "../screens/shipper/TrackingCodeShipperScreen";

export const ShipperRoutes = [
  { path: "/", exact: true, component: TrackingCodeShipperScreen },
  { path: "/tracking", exact: true, component: TrackingCodeScreen },
  { path: "/tracking/:id", exact: true, component: TrackingCodeScreen },
  { path: "/account/profile", exact: true, component: ProfileScreen },
  { path: "/account/resetpassword", exact: true, component: ResetPasswordScreen },
]